import axios from 'axios';
import Constants from '@/constants';

class ProductPostingService {
    constructor() {
        this.table_name = 'realestate.product_posting_by_date'
    }

    async create_v2(product_id, content, content_img_url, product_url, created_at, created_by, platforms, mediaJson = null) {
        // platforms will be in this structure:
        // - [key, value]
        var columns = ['product_id', 'content', 'content_img_url', 'product_url', 'created_by', 'created_at', 'media'];
        var values = [
            product_id,
            `"${content}"`,
            `"${content_img_url}"`,
            `"${product_url}"`,
            `"${created_by}"`,
            `"${created_at}"`,
            mediaJson ? `'${mediaJson.replace(/'/g, "''")}'` : 'NULL'
        ];

        // Loop through platforms, an array of objects with the structure {platform_key:'', platform_name:''}
        // Add safety check to ensure platforms is an array
        if (platforms && Array.isArray(platforms)) {
            platforms.forEach(platform => {
                if (platform && platform.platform_key) {
                    columns.push(platform.platform_key);
                    values.push(1);
                }
            });
        }

        var query = 'INSERT INTO realestate.product_posting_2 (';
        query += columns.join(',');
        query += ') VALUES (';
        query += values.join(',');
        query += ');';

        //query = encodeURIComponent(query);
        console.log('trying to submit a new query ', query);

        var url = Constants.HOST_URL + 'runQuery/insert';
        var response = await axios.post(url,{
            query: query
        });
        if(!response.data) {
            alert('Error while downloading record ' + this.id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async removePostByDate(productId, created_at) {
        var query = `DELETE FROM realestate.product_posting_2 WHERE product_id=${productId} and created_at='${created_at}'`;

        var url = Constants.HOST_URL + 'runDeleteQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading record ' + this.id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async setGroupConcatMaxLen() {
        var query = `SET SESSION group_concat_max_len = 100000;`

        query = encodeURIComponent(query);
        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error set group concat max length');
            return;
        }
        console.log(response.data);
        return response.data
    }

    async listByProductIdAndOwner(productId, created_by) {
        var query = `
        SELECT
         pp.product_id AS id,
         p.code AS code,
         p.fullname AS fullname,
         p.street AS street,
         '' as platform,
         pp.*
        FROM realestate.product_posting_2 pp
            LEFT JOIN realestate.products p
            ON pp.product_id = p.id

         WHERE pp.product_id=${productId} and pp.created_by = '${created_by}'
        ORDER BY pp.created_at DESC
         ;
        `
        
                query = encodeURIComponent(query);
                var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
                var response = await axios.get(url);
                if(!response.data) {
                    alert('Error while downloading record by product id ' + productId);
                    return;
                }
        
                console.log(response.data);
                return response.data
    }

    async listByProductId(productId) {
        var query = `
        SELECT
        pp.product_id AS id,
        p.code AS code,
        p.fullname AS fullname,
        p.street AS street,
        '' as platform,
        pp.*
       FROM realestate.product_posting_2 pp
           LEFT JOIN realestate.products p
           ON pp.product_id = p.id

        WHERE pp.product_id=${productId}
       ORDER BY pp.created_at DESC
 ;`;

        query = encodeURIComponent(query);
        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading record by product id ' + productId);
            return;
        }

        console.log(response.data);
        return response.data
    }
  
    async getDetail(id) {
        var query = 'SELECT * ';
        query += `FROM realestate.product_posting_2 `;
        query += 'WHERE id=' + id + ';';

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data || response.data.length != 1) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async getProductStatus(productId) {
        var query = 'SELECT posting_status, posting_reminder ';
        query += `FROM realestate.products `;
        query += 'WHERE id=' + productId + ';';

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data || response.data.length != 1) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async updateProductStatus(productId, newStatus) {
        return this.updateProductColumn(productId, 'posting_status', newStatus, 'text');
    }

    async updateProductPostingColumnById(productPostingId, column, value, type) {
        var query = '';

        if(type === 'text') {
            query = `UPDATE realestate.product_posting_2 SET ${column}='${value}' WHERE id=${productPostingId};`;
        } else if(type === 'number' || type === 'boolean') {
            query = `UPDATE realestate.product_posting_2 SET ${column}=${value} WHERE id=${productPostingId};`;
        }

        // var url = Constants.HOST_URL + 'runUpdateQuery?query=' + query;
        var url = Constants.HOST_URL + 'runQuery/insert';
        var response = await axios.post(url,{
            query: query
        });
        if(!response.data) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async updateProductPostingColumnByProductIdAndDate(productId, column, value, type, date) {
        var query = '';

        if(type === 'text') {
            query = `UPDATE realestate.product_posting_2 SET ${column}='${value}' WHERE product_id=${productId} and created_at='${date}';`;
        } else if(type === 'number' || type === 'boolean') {
            query = `UPDATE realestate.product_posting_2 SET ${column}=${value} WHERE product_id=${productId} and created_at='${date}';`;
        }

        // var url = Constants.HOST_URL + 'runUpdateQuery?query=' + query;
        var url = Constants.HOST_URL + 'runQuery/insert';
        var response = await axios.post(url,{
            query: query
        });
        if(!response.data) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async updateProductColumn(productId, column, value, type) {
        var query = '';

        if(type === 'text') {
            query = `UPDATE realestate.products SET ${column}='${value}' WHERE id=${productId};`;
        } else if(type === 'number' || type === 'boolean') {
            query = `UPDATE realestate.products SET ${column}=${value} WHERE id=${productId};`;
        }

        // var url = Constants.HOST_URL + 'runUpdateQuery?query=' + query;
        var url = Constants.HOST_URL + 'runQuery/insert';
        var response = await axios.post(url,{
            query: query
        });
        if(!response.data) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async deleteProductPostingById(id) {
        var query = `DELETE FROM realestate.product_posting_2 WHERE id =${id}`;

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);
        }
        catch (e) {
            alert(e);
        }
    }

    async updateGroupProductsStatus(productIds, newStatus) {
        return this.updateGroupProductsColumn(productIds, 'posting_status', newStatus, 'text');
    }

    async updateGroupProductsColumn(productIds, column, value, type) {
        var query = '';

        var ids = productIds.join();

        if(type === 'text') {
            query = `UPDATE realestate.products SET ${column}='${value}' WHERE id IN (${ids});`;
        } else if(type === 'number') {
            query = `UPDATE realestate.products SET ${column}=${value} WHERE id IN (${ids});`;
        }

        var url = Constants.HOST_URL + 'runUpdateQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async deleteGroupProductPostings(productIds) {
        var query = `DELETE FROM realestate.product_posting_2 WHERE product_id IN (${productIds.join(',')})`;

        var url = Constants.HOST_URL + 'runDeleteQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while deleting records');
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async getProductPostings(params = {}) {
        const { page = 1, limit = 20, filters = [] } = params;
        const offset = (page - 1) * limit;
        const tableName = 'realestate.product_posting_summary_7'; // Use the correct table name
        
        // Build where conditions from filters
        let whereConditions = [];
        if (filters && filters.length > 0) {
            filters.forEach(filter => {
                // Handle numeric ranges independently from `value`
                if (filter.type === 'number') {
                    const fromVal = (filter.from !== null && filter.from !== undefined && `${filter.from}`.trim() !== '')
                        ? Number(filter.from)
                        : null;
                    const toVal = (filter.to !== null && filter.to !== undefined && `${filter.to}`.trim() !== '')
                        ? Number(filter.to)
                        : null;

                    if (fromVal !== null) {
                        whereConditions.push(`${filter.col} >= ${fromVal}`);
                    }
                    if (toVal !== null) {
                        whereConditions.push(`${filter.col} <= ${toVal}`);
                    }
                    return; // handled
                }

                // Handle multi-select filters
                if (filter.type === 'multi-select') {
                    console.log('filter type multi-select', filter);
                    console.log('filter.value', filter.value);
                    if (Array.isArray(filter.value) && filter.value.length > 0) {
                        const conditions = filter.value.filter(v => v && typeof v === 'string' && v.trim() !== '').map(v => `${filter.col} = '${v}'`);
                        if (conditions.length > 0) {
                            console.log('conditions', conditions);
                            whereConditions.push(`(${conditions.join(' OR ')})`);
                        }
                    } else if (filter.value && typeof filter.value === 'string' && filter.value.trim() !== '') {
                        // Handle case where multi-select has a single string value
                        whereConditions.push(`${filter.col} = '${filter.value}'`);
                    }
                    return; // handled
                }

                // For non-boolean filters, apply when value is non-empty
                if (filter.type !== 'boolean' && filter.value !== null && filter.value !== undefined && `${filter.value}`.trim() !== '') {
                    if (filter.type === 'text') {
                        whereConditions.push(`UPPER(${filter.col}) LIKE UPPER('%${filter.value}%')`);
                    } else if (filter.type === 'select') {
                        whereConditions.push(`${filter.col} = '${filter.value}'`);
                    }
                }

                // For boolean filters: only apply when true; when false, don't filter (to include NULL as well)
                if (filter.type === 'boolean') {
                    if (filter.value === true || filter.value === 1 || filter.value === '1') {
                        whereConditions.push(`${filter.col} = 1`);
                    }
                }
            });
        }

        let whereClause = '';
        if (whereConditions.length > 0) {
            whereClause = 'WHERE ' + whereConditions.join(' AND ');
        }

        // Count query
        const countQuery = `
            SELECT COUNT(*) as total 
            FROM ${tableName} 
            ${whereClause}
        `;

        // Data query
        const dataQuery = `
            SELECT * 
            FROM ${tableName} 
            ${whereClause}
            ORDER BY last_posting_date DESC
            LIMIT ${limit} OFFSET ${offset}
        `;

        try {
            // Get total count
            const countUrl = Constants.HOST_URL + 'runSelectQuery?query=' + encodeURIComponent(countQuery);
            const countResponse = await axios.get(countUrl);
            const total = countResponse.data[0]?.total || 0;

            // Get data
            const dataUrl = Constants.HOST_URL + 'runSelectQuery?query=' + encodeURIComponent(dataQuery);
            const dataResponse = await axios.get(dataUrl);
            const data = dataResponse.data || [];

            return {
                data,
                total,
                page,
                limit
            };
        } catch (error) {
            console.error('Error fetching product postings:', error);
            throw error;
        }
    }
  }
  
  
export default ProductPostingService;